import http from '@root/utils/axios/admin';

let state = {
    CommentsList: [],
    Comment: {
        data: {},
        error: {}
    },
}

let actions = {

    fetchCommentsList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('subscriber/videos/' + filter.video_id + '/comments', { params: filter }).then((response) => {
                commit('setCommentsList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteComment({ commit }, data = {}) {
        return http.delete('subscriber/videos/' + data.video_id + '/comments/' + data.id);
    },


    CreateComment({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('subscriber/videos/' + data.video_id + '/comments', data).then((response) => {
                commit('setComment', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCommentError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateComment({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('subscriber/videos/' + data.video_id + '/comments/' + data.id, data).then((response) => {
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setCommentError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setCommentsList(state, data) {
        state.CommentsList = data;
    },
    setComment(state, data) {
        state.Comment.data = data;
    },
    setCommentError(state, data) {
        state.Comment.error = data;
    },
    cleanCommentError(state) {
        state.Comment.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}